<template>
  <div class="sign-overview-page">
    <section class="sign-overview-header">
      <div class="header-title">
        <span class="header-kicker">签约数据</span>
        <h1>签约情况一览</h1>
        <p>按月份聚合部门签约动态，点击部门查看人员明细</p>
      </div>
      <div class="header-period">
        <span>当前周期</span>
        <strong>{{ periodText }}</strong>
      </div>
    </section>

    <section class="sign-overview-content">
      <div class="sign-overview-toolbar">
        <div class="toolbar-field">
          <span class="toolbar-label">统计月份</span>
          <el-date-picker
            v-model='selectMonths'
            class="month-picker"
            placeholder='月份选择'
            size="small"
            type='monthrange'
            format='yyyy年MM月'
            value-format='yyyy-MM'
            @change='getList'>
          </el-date-picker>
        </div>
        <div class="toolbar-actions">
          <el-button @click='getList' type='primary' size="small" icon='el-icon-search'>查询</el-button>
          <el-button
            :loading='downloadLoading'
            v-if='hasAuthority("sign_summary_export")'
            type='primary'
            size="small"
            plain
            @click='exportExcel'
            icon='el-icon-download'>
            导出列表
          </el-button>
        </div>
      </div>

      <template v-if='hasAuthority("sign_summary_page")'>
        <div class="overview-stats">
          <article
            v-for="item in overviewCards"
            :key="item.label"
            :class="['overview-stat-card', item.type]">
            <div class="stat-card-top">
              <span>{{ item.label }}</span>
              <i :class="item.icon"></i>
            </div>
            <strong>{{ item.value }}</strong>
            <p>{{ item.desc }}</p>
          </article>
        </div>

        <div class="sign-overview-layout">
          <section class="overview-panel overview-table-panel" :style="panelStyle">
            <div class="panel-header">
              <div>
                <h2>部门汇总</h2>
                <p>点击部门行可查看右侧明细</p>
              </div>
              <span class="panel-count">共 {{ overviewTotals.dept_qty }} 个部门</span>
            </div>
            <el-table
              @row-click='dbRow'
              :data='dataList'
              ref='multipleTable'
              row-key='id'
              id='kolAnalysisTable'
              class="dept-summary-table"
              :height="summaryTableHeight"
              size="small"
              highlight-current-row
              show-summary
              v-loading='isLading'
              border
              stripe>
              <el-table-column align='center' label='序号' type='index' width='60'></el-table-column>
              <el-table-column align='left' prop='dept_name' show-overflow-tooltip label='部门' min-width='140'></el-table-column>
              <el-table-column align='center' prop='sign_qty' show-overflow-tooltip label='在约红人数量' sortable min-width='150'></el-table-column>
              <el-table-column align='center' prop='signing_qty' sortable label='签入新人数量' min-width='130'></el-table-column>
              <el-table-column align='center' prop='fired_qty' sortable label='解约账号数量' min-width='130'></el-table-column>
            </el-table>
          </section>

          <section class="overview-panel overview-detail-panel" :style="panelStyle">
            <div class="panel-header detail-panel-header">
              <div>
                <h2>{{ selectedDeptName }}</h2>
                <p>{{ selectedDeptDesc }}</p>
              </div>
              <el-tag v-if="deptInfo.dept_name" size="small" effect="plain">已选部门</el-tag>
            </div>

            <div v-if="deptInfo.dept_name" class="detail-blocks">
              <article class="detail-section detail-new">
                <div class="detail-section-header">
                  <div>
                    <span class="detail-dot"></span>
                    <h3>签入新人列表</h3>
                  </div>
                  <strong>{{ detailCounts.signing }}</strong>
                </div>
                <el-table
                  :data='deptInfo.signing_list'
                  :max-height="246"
                  class="detail-table"
                  size="mini"
                  stripe>
                  <template slot="empty">
                    <div class="table-empty">暂无数据</div>
                  </template>
                  <el-table-column type='index' label='序号' width='56'></el-table-column>
                  <el-table-column label='红人昵称' prop='nickname' min-width='120' show-overflow-tooltip></el-table-column>
                  <el-table-column label='签约日期' prop='sign_date' min-width='110'>
                    <template slot-scope='{row}'>
                      {{ $utils.parseTime(row.sign_date, '{y}-{m}-{d}') }}
                    </template>
                  </el-table-column>
                  <el-table-column label='签约到期日期' prop='sign_end' min-width='110'>
                    <template slot-scope='{row}'>
                      {{ $utils.parseTime(row.sign_end, '{y}-{m}-{d}') }}<span v-if="row.fired_at" style="color: #f0ad4e;font-size: 0.8em">（解约日期：{{row.fired_at|| '-'}}）</span>
                    </template>
                  </el-table-column>
                </el-table>
              </article>

              <article class="detail-section detail-fired">
                <div class="detail-section-header">
                  <div>
                    <span class="detail-dot"></span>
                    <h3>解约账号列表</h3>
                  </div>
                  <strong>{{ detailCounts.fired }}</strong>
                </div>
                <el-table
                  :data='deptInfo.fired_list'
                  :max-height="246"
                  class="detail-table"
                  size="mini"
                  stripe>
                  <template slot="empty">
                    <div class="table-empty">暂无数据</div>
                  </template>
                  <el-table-column type='index' label='序号' width='56'></el-table-column>
                  <el-table-column label='红人昵称' prop='nickname' min-width='120' show-overflow-tooltip></el-table-column>
                  <el-table-column label='签约日期' prop='sign_date' min-width='110'>
                    <template slot-scope='{row}'>
                      {{ $utils.parseTime(row.sign_date, '{y}-{m}-{d}') }}
                    </template>
                  </el-table-column>
                  <el-table-column label='解约日期' prop='fired_at' min-width='110'>
                    <template slot-scope='{row}'>
                      {{ $utils.parseTime(row.fired_at, '{y}-{m}-{d}') }}<span v-if="row.fired_at" style="color: #f0ad4e;font-size: 0.9em">（签约到期：{{row.sign_end|| '-'}}）</span>
                    </template>
                  </el-table-column>
                </el-table>
              </article>

              <article class="detail-section detail-active">
                <div class="detail-section-header">
                  <div>
                    <span class="detail-dot"></span>
                    <h3>在约红人列表</h3>
                  </div>
                  <strong>{{ detailCounts.sign }}</strong>
                </div>
                <el-table
                  :data='deptInfo.sign_list'
                  :max-height="246"
                  class="detail-table"
                  size="mini"
                  stripe>
                  <template slot="empty">
                    <div class="table-empty">暂无数据</div>
                  </template>
                  <el-table-column type='index' label='序号' width='56'></el-table-column>
                  <el-table-column label='红人昵称' prop='nickname' min-width='140' show-overflow-tooltip></el-table-column>
                  <el-table-column label='签约日期' prop='sign_date' min-width='120'>
                    <template slot-scope='{row}'>
                      {{ $utils.parseTime(row.sign_date, '{y}-{m}-{d}') }}
                    </template>
                  </el-table-column>
                  <el-table-column label='签约到期日期' prop='sign_end' min-width='110'>
                    <template slot-scope='{row}'>
                      {{ $utils.parseTime(row.sign_end, '{y}-{m}-{d}') }}<span v-if="row.fired_at" style="color: #f0ad4e;font-size: 0.8em">（解约日期：{{row.fired_at|| '-'}}）</span>
                    </template>
                  </el-table-column>
<!--                  <el-table-column label='签约合同状态' prop='sign_status' min-width='100' show-overflow-tooltip></el-table-column>-->
                </el-table>
              </article>
            </div>

            <div v-else class="detail-empty">
              <i class="el-icon-s-data"></i>
              <strong>请选择部门</strong>
              <span>点击左侧部门行后查看签入、解约和在约红人明细</span>
            </div>
          </section>
        </div>
      </template>
    </section>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import ExportBtn from '@/components/export/ExportBtn'
import * as XLSX from 'xlsx-js-style'
import {hasAuthority} from '@/utils/hasAuthority'

export default {
  name: 'signOverview',
  data() {
    return {
      selectMonths: [],
      dataList: [],
      isLading: false,
      downloadLoading: false,
      viewportHeight: typeof window !== 'undefined' ? window.innerHeight : 900,
      today: '',
      deptInfo: {
        //部门名
        dept_id: null,
        dept_name: null,
        sign_list: [],
        //签入新人数量
        signing_list: [],
        // 解约账号数量
        fired_list: []

      }
    }
  },

  components: {
    ExportBtn
  },
  computed: {
    ...mapGetters(['userPermissions']),
    periodText() {
      if (this.selectMonths && this.selectMonths.length === 2) {
        return `${this.selectMonths[0]} 至 ${this.selectMonths[1]}`
      }
      return '全部月份'
    },
    overviewTotals() {
      return this.dataList.reduce((total, item) => {
        total.dept_qty += 1
        total.sign_qty += Number(item.sign_qty) || 0
        total.signing_qty += Number(item.signing_qty) || 0
        total.fired_qty += Number(item.fired_qty) || 0
        return total
      }, {
        dept_qty: 0,
        sign_qty: 0,
        signing_qty: 0,
        fired_qty: 0
      })
    },
    overviewCards() {
      return [
        {
          label: '统计部门',
          value: this.overviewTotals.dept_qty,
          desc: '当前周期覆盖部门',
          icon: 'el-icon-office-building',
          type: 'dept'
        },
        {
          label: '在约红人（不限统计月份）',
          value: this.overviewTotals.sign_qty,
          desc: '各部门在约红人合计',
          icon: 'el-icon-user-solid',
          type: 'active'
        },
        {
          label: '签入新人',
          value: this.overviewTotals.signing_qty,
          desc: '周期内新增签约账号',
          icon: 'el-icon-circle-plus',
          type: 'new'
        },
        {
          label: '解约账号',
          value: this.overviewTotals.fired_qty,
          desc: '周期内解约账号合计',
          icon: 'el-icon-remove',
          type: 'fired'
        }
      ]
    },
    selectedDeptName() {
      return this.deptInfo.dept_name ? `${this.deptInfo.dept_name} 明细` : '部门明细'
    },
    selectedDeptDesc() {
      return this.deptInfo.dept_name ? '当前部门签约人员变动' : '从左侧部门汇总中选择一行'
    },
    detailCounts() {
      return {
        signing: this.deptInfo.signing_list ? this.deptInfo.signing_list.length : 0,
        fired: this.deptInfo.fired_list ? this.deptInfo.fired_list.length : 0,
        sign: this.deptInfo.sign_list ? this.deptInfo.sign_list.length : 0
      }
    },
    summaryTableHeight() {
      return Math.max(340, this.viewportHeight - 490)
    },
    panelStyle() {
      return {
        height: `${this.summaryTableHeight + 57}px`
      }
    }
  },
  methods: {
    hasAuthority,
    handleResize() {
      this.viewportHeight = window.innerHeight
    },
    async dbRow(row) {
      const dept_id = row.dept_id || ''
      if (dept_id && this.selectMonths && this.selectMonths.length > 0) {
        const { dept_info, signing_list, fired_list, sign_list } = await this.$api.getSignSummaryDetail({
          dept_id: dept_id,
          date_range: this.selectMonths
        })
        this.deptInfo = {
          dept_id: dept_info ? dept_info.dpt_id : '',
          dept_name: dept_info ? dept_info.name : '',
          signing_list: signing_list,
          sign_list: sign_list,
          fired_list: fired_list
        }
      }
    },
    async getList() {
      this.isLading = true
      this.dataList = []
      const params = this.selectMonths && this.selectMonths.length === 2 ? { date_range: this.selectMonths } : {}
      const { list } = await this.$api.signInfoOverview(params)
      this.dataList = list || []
      this.isLading = false
      if (this.dataList) {
        await this.dbRow(this.dataList[0])
      }

    },
    defaultTime() {
      const date = new Date()
      //年份选择：默认当月
      const end = date.getFullYear() + '-' + (Number(date.getMonth() + 1) < 10 ? '0' + Number(date.getMonth() + 1) : date.getMonth() + 1)
      const start = date.getFullYear() + '-' + '01'
      this.selectMonths = [start, end]
    },
    exportExcel: function() {
      this.downloadLoading = true
      const xlsxParam = { raw: false } //转换成excel时，使用原始的格式
      /* 生成工作表 */
      const workbook = XLSX.utils.book_new()
      /* 从表生成工作簿对象 */

      let worksheet = XLSX.utils.table_to_sheet(
          document.querySelector('#kolAnalysisTable'),
          xlsxParam
      )

      /* 设置工作簿样式 */
      worksheet = this.worksheetStyle(worksheet)

      /* 工作簿导出 */
      XLSX.utils.book_append_sheet(workbook, worksheet, '招商情况一览')
      XLSX.writeFile(workbook, `招商情况一览.xlsx`)

      this.downloadLoading = false
    },
    /* 设置工作簿样式 */
    worksheetStyle: function(worksheet) {
      // 表样式设置
      const colsLength = 14
      const cols = [] // 设置每列的宽度
      // wpx 字段表示以像素为单位，wch 字段表示以字符为单位
      for (let i = 0; i <= colsLength; i++) {
        const col = {}

        if (i == 0) {
          col.wch = 30
          col.wpx = 50
        } else if (i == 1) {
          col.wch = 50

        } else {
          col.wch = 18
        }
        cols.push(col)
      }
      worksheet['!cols'] = cols // 设置列宽信息到工作表
      //以下是样式设置，样式设置放在组织完数据之后，xlsx-js-style的核心API就是SheetJS的
      Object.keys(worksheet).forEach(key => {

        // 非!开头的属性都是单元格
        if (!key.startsWith('!')) {
          if (key.indexOf('A') != -1 || ['A1', 'B1', 'C1', 'D1', 'E1'].includes(key)) {
            if (key.indexOf('A') != -1) {
              if (key === 'A1') {
                worksheet[key].s = {
                  wpx: 50,
                  font: {
                    sz: '14',
                    name: 'Microsoft YaHei',
                    color: { rgb: 'FFFFFF' }

                  },
                  alignment: {
                    horizontal: 'center',
                    vertical: 'center',
                    wrapText: true
                  },
                  border: {
                    top: { style: 'thin' },
                    right: { style: 'thin' },
                    bottom: { style: 'thin' },
                    left: { style: 'thin' }
                  },
                  fill: {
                    fgColor: { rgb: 'ff3176' }
                  }
                }
              } else
                worksheet[key].s = {
                  font: {
                    sz: '12',
                    name: 'Microsoft YaHei'
                  },
                  alignment: {
                    horizontal: 'center',
                    vertical: 'center',
                    wrapText: true
                  },
                  border: {
                    top: { style: 'thin' },
                    right: { style: 'thin' },
                    bottom: { style: 'thin' },
                    left: { style: 'thin' }
                  }
                }
            } else {
              worksheet[key].s = {
                font: {
                  sz: '12',
                  color: { rgb: 'FFFFFF' },
                  name: 'Microsoft YaHei'
                },
                alignment: {
                  horizontal: 'center',
                  vertical: 'center',
                  wrapText: true
                },
                border: {
                  top: { style: 'thin' },
                  right: { style: 'thin' },
                  bottom: { style: 'thin' },
                  left: { style: 'thin' }
                },
                fill: {
                  fgColor: { rgb: 'ff3176' }
                }
              }
            }
            worksheet[key].t = 's'
          } else if (key.indexOf('F') != -1) {
            worksheet[key].s = {
              font: {
                sz: '14',
                name: 'Microsoft YaHei',
                color: { rgb: 'FFFFFF' }

              },
              alignment: {
                horizontal: 'center',
                vertical: 'center',
                wrapText: true
              },
              border: {
                // top: { style: 'thin' },
                // right: { style: 'thin' },
                // bottom: { style: 'thin' },
                // left: { style: 'thin' }
              },
              fill: {
                fgColor: { rgb: 'ff3176' }
              }
            }
          } else {
            worksheet[key].s = {
              font: {
                sz: '14'
              },
              alignment: {
                horizontal: 'right',
                vertical: 'right',
                wrapText: true
              },
              border: {
                top: { style: 'thin' },
                right: { style: 'thin' },
                bottom: { style: 'thin' },
                left: { style: 'thin' }
              }
            }
            worksheet[key].t = 'n'
            worksheet[key].s.numFmt = 0
          }
        }

      })

      return worksheet
    }

  },
  mounted() {
    this.getList()
    window.addEventListener('resize', this.handleResize)
  },
  created() {
    this.defaultTime()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style scoped lang='scss'>
.sign-overview-page {
  min-height: 100%;
  padding: 10px 14px;
  background: #f5f7fb;
  box-sizing: border-box;
  overflow: auto;
}

.sign-overview-header {
  min-height: 82px;
  padding: 12px 18px;
  background: #ffffff;
  border: 1px solid #e7ebf2;
  border-radius: 8px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.header-title {
  min-width: 0;
}

.header-kicker {
  height: 22px;
  padding: 0 9px;
  color: #ff3176;
  background: #fff0f6;
  border: 1px solid #ffd1e2;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  line-height: 22px;
}

.header-title h1 {
  margin: 6px 0 2px;
  color: #172033;
  font-size: 22px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0;
}

.header-title p {
  margin: 0;
  color: #7a8494;
  font-size: 13px;
  line-height: 18px;
}

.header-period {
  min-width: 200px;
  padding: 10px 12px;
  background: #f8fafc;
  border: 1px solid #edf1f6;
  border-radius: 8px;
  box-sizing: border-box;
}

.header-period span {
  color: #8a94a6;
  display: block;
  font-size: 12px;
  line-height: 18px;
}

.header-period strong {
  margin-top: 2px;
  color: #263142;
  display: block;
  font-size: 15px;
  font-weight: 700;
  line-height: 22px;
}

.sign-overview-content {
  margin-top: 8px;
}

.sign-overview-toolbar,
.overview-panel,
.overview-stat-card {
  background: #ffffff;
  border: 1px solid #e7ebf2;
  border-radius: 8px;
  box-sizing: border-box;
}

.sign-overview-toolbar {
  min-height: 50px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  flex-wrap: wrap;
}

.toolbar-field,
.toolbar-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.toolbar-label {
  color: #667085;
  font-size: 13px;
  font-weight: 600;
}

.month-picker {
  width: 310px;
}

.sign-overview-toolbar ::v-deep .el-button {
  margin-left: 0 !important;
}

.overview-stats {
  margin-top: 8px;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}

.overview-stat-card {
  min-height: 86px;
  padding: 12px 14px;
  position: relative;
  overflow: hidden;
}

.overview-stat-card::before {
  content: '';
  width: 4px;
  position: absolute;
  left: 0;
  top: 14px;
  bottom: 14px;
  border-radius: 0 4px 4px 0;
}

.overview-stat-card.dept::before {
  background: #2f7cf6;
}

.overview-stat-card.active::before {
  background: #14b8a6;
}

.overview-stat-card.new::before {
  background: #ff9f1c;
}

.overview-stat-card.fired::before {
  background: #f56c6c;
}

.stat-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.stat-card-top span {
  color: #7a8494;
  font-size: 13px;
  line-height: 20px;
}

.stat-card-top i {
  width: 30px;
  height: 30px;
  color: #2f7cf6;
  background: #eff6ff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.overview-stat-card.active .stat-card-top i {
  color: #0f9f8b;
  background: #ecfdf5;
}

.overview-stat-card.new .stat-card-top i {
  color: #d97706;
  background: #fff7ed;
}

.overview-stat-card.fired .stat-card-top i {
  color: #f56c6c;
  background: #fff1f2;
}

.overview-stat-card strong {
  margin-top: 4px;
  color: #172033;
  display: block;
  font-size: 24px;
  font-weight: 700;
  line-height: 30px;
}

.overview-stat-card p {
  margin: 0;
  color: #8a94a6;
  font-size: 12px;
  line-height: 18px;
}

.sign-overview-layout {
  margin-top: 10px;
  display: grid;
  grid-template-columns: minmax(560px, 0.95fr) minmax(420px, 1.05fr);
  gap: 10px;
  align-items: flex-start;
}

.overview-panel {
  min-width: 0;
  overflow: hidden;
}

.panel-header {
  min-height: 56px;
  padding: 9px 14px;
  border-bottom: 1px solid #edf1f6;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.panel-header h2 {
  margin: 0;
  color: #172033;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
}

.panel-header p {
  margin: 1px 0 0;
  color: #8a94a6;
  font-size: 12px;
  line-height: 18px;
}

.panel-count {
  height: 26px;
  padding: 0 10px;
  color: #667085;
  background: #f8fafc;
  border: 1px solid #edf1f6;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  font-size: 12px;
  line-height: 26px;
}

.dept-summary-table {
  width: 100%;
}

.overview-table-panel ::v-deep .el-table {
  border-left: 0;
  border-right: 0;
}

.overview-table-panel ::v-deep .el-table th {
  color: #475467;
  background: #f8fafc;
  font-weight: 600;
}

.overview-table-panel ::v-deep .el-table td,
.overview-table-panel ::v-deep .el-table th {
  border-color: #edf1f6;
}

.overview-table-panel ::v-deep .el-table__body tr {
  cursor: pointer;
}

.overview-table-panel ::v-deep .el-table__body tr.current-row > td {
  background: #fff6fa !important;
}

.overview-table-panel ::v-deep .el-table__footer-wrapper td {
  color: #172033;
  background: #fbfcfe;
  font-weight: 700;
}

.overview-detail-panel {
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.detail-panel-header ::v-deep .el-tag {
  color: #ff3176;
  border-color: #ffd1e2;
  background: #fff0f6;
}

.detail-blocks {
  flex: 1;
  min-height: 0;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
}

.detail-section {
  border: 1px solid #edf1f6;
  border-radius: 8px;
  flex: 0 0 auto;
  overflow: hidden;
}

.detail-section-header {
  min-height: 40px;
  padding: 0 12px;
  background: #fbfcfe;
  border-bottom: 1px solid #edf1f6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.detail-section-header > div {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.detail-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex: 0 0 auto;
}

.detail-new .detail-dot {
  background: #ff9f1c;
}

.detail-fired .detail-dot {
  background: #f56c6c;
}

.detail-active .detail-dot {
  background: #14b8a6;
}

.detail-section-header h3 {
  margin: 0;
  color: #263142;
  font-size: 14px;
  font-weight: 700;
  line-height: 22px;
}

.detail-section-header strong {
  min-width: 28px;
  height: 24px;
  padding: 0 8px;
  color: #344054;
  background: #ffffff;
  border: 1px solid #e7ebf2;
  border-radius: 12px;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  line-height: 22px;
}

.detail-table {
  width: 100%;
}

.detail-table ::v-deep .el-table__header th {
  color: #667085;
  background: #ffffff;
  font-weight: 600;
}

.detail-table ::v-deep .el-table td,
.detail-table ::v-deep .el-table th {
  border-color: #edf1f6;
}

.table-empty {
  padding: 16px 0;
  color: #98a2b3;
  font-size: 12px;
}

.detail-empty {
  flex: 1;
  min-height: 0;
  padding: 32px;
  color: #8a94a6;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}

.detail-empty i {
  color: #d0d5dd;
  font-size: 52px;
}

.detail-empty strong {
  margin-top: 14px;
  color: #344054;
  font-size: 16px;
  line-height: 24px;
}

.detail-empty span {
  margin-top: 6px;
  max-width: 280px;
  color: #98a2b3;
  font-size: 13px;
  line-height: 20px;
}

@media (max-width: 1360px) {
  .sign-overview-layout {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 980px) {
  .overview-stats {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 720px) {
  .sign-overview-page {
    padding: 12px;
  }

  .sign-overview-header {
    padding: 18px;
    align-items: flex-start;
    flex-direction: column;
  }

  .header-period,
  .month-picker {
    width: 100%;
    min-width: 0;
  }

  .toolbar-field,
  .toolbar-actions {
    width: 100%;
  }

  .sign-overview-toolbar ::v-deep .el-button {
    flex: 1;
  }

  .overview-stats {
    grid-template-columns: 1fr;
  }

  .panel-header {
    align-items: flex-start;
    flex-direction: column;
  }
}
</style>
